import styled from 'styled-components'

export const SquareCheckBox = styled.div<{ active?: boolean }>`
  position: relative;
  width: 1rem;
  height: 1rem;
  padding: 2px;
  border: ${(props) => props.theme.inputBorder};
  border-radius: 4px;
  cursor: pointer;

  &::after {
    background-color: ${(props) => (props.active ? props.theme.colorOrange : 'transparent')};
    position: absolute;
    content: '';
    border-radius: 2px;
    width: 0.7rem;
    height: 0.7rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const CheckChipContainer = styled.div<{ active?: boolean }>`
  ${(props) => props.theme.content};
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 5px 10px;
  ${(props) => props.active && 'border:1px solid #ff9900;'}
  cursor: pointer;
`

export const ChipsContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`
